define('features/overlayGameLauncher/statViewModelInjections',[
    'knockout',
    'underscore'
], function (ko, _) {

    return function (GemsViewModel,
                     XPViewModel,
                     XPMilestonesViewModel,
                     XPRandomMilestonesViewModel,
                     ShopViewModel,
                     adventureOverride) {

        var adventureModels = {
            VC_PLAIN: [
                XPViewModel,
                GemsViewModel,
                ShopViewModel
            ],
            VC_WITH_CHESTS_MILESTONE: [
                XPMilestonesViewModel,
                GemsViewModel,
                ShopViewModel
            ],
            VC_WITH_CHESTS_RANDOM: [
                XPRandomMilestonesViewModel,
                GemsViewModel,
                ShopViewModel
            ]
        };

        return ko.pureComputed(function () {
            return _.get(adventureModels, adventureOverride(), adventureModels.VC_PLAIN);
        });
    };
});

